import { z } from 'zod';

export const savedProgramSchema = z
  .object({
    id: z.number(),
  })
  .passthrough();

export type SavedProgram = z.infer<typeof savedProgramSchema>;
